import * as $ from 'jquery';
import 'jquery-migrate';

declare global {
	interface Window {
		jQuery: JQueryStatic;
	}
}

window.jQuery = $;
export default $;

import '../templates/main-menu/script.ts';
import '../templates/menu/script.ts';
